/**
 * BioBlue locale switcher — re-measure sticky header CSS vars after language reload.
 */
(function () {
  var PENDING_KEY = 'bb-locale-switch-pending';

  function remeasureLayoutHeights() {
    document.querySelectorAll('height-observer[variable]').forEach(function (el) {
      var name = el.getAttribute('variable');
      if (!name) return;
      var height = Math.round(el.getBoundingClientRect().height);
      if (height > 0) {
        document.documentElement.style.setProperty('--' + name + '-height', height + 'px');
      }
    });
  }

  function afterLocaleSwitch() {
    try {
      if (sessionStorage.getItem(PENDING_KEY) !== '1') return;
      sessionStorage.removeItem(PENDING_KEY);
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
      remeasureLayoutHeights();
      requestAnimationFrame(function () {
        remeasureLayoutHeights();
      });
    } catch (e) {
      /* private mode */
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('bb-locale-form')) {
        return;
      }
      try {
        sessionStorage.setItem(PENDING_KEY, '1');
      } catch (e) {
        /* private mode */
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', afterLocaleSwitch, { once: true });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      requestAnimationFrame(remeasureLayoutHeights);
    });
  }
})();
